import "../../cssfiles/homepage.css";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";

export default function CustomCancelButton({
  buttonText,
  onClick,
  id,
  width,
  disabled,
  fontSize,
}) {
  const theme = useSelector((state) => state.themedata.theme);
  return (
    <Button
      disabled={disabled ? disabled : false}
      style={{
        padding: "8px 16px",
        borderRadius: "20px",
        fontSize: fontSize ? `${fontSize}px` : "16px",
        textTransform: "none",
        fontFamily: "Roboto",
        cursor: "pointer",
      }}
      sx={{
        boxSizing: "border-box",
        border: "1px solid",
        height: "35px",
        minWidth: "70px",
        width: width ? width : "auto",
        color: "#7E7E7E", ///C1C1C1
        fontWeight: 400,
        borderColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
        backgroundColor:
          disabled === true
            ? theme === "light"
              ? "#C1C1C1"
              : "#3C3C3C"
            : "none",
        "&:hover": {
          backgroundColor: "none",
          border: "2px solid",
          borderColor: theme === "light" ? "#005C8E" : "#FFFFFF",
          color: theme === "light" ? "#005C8E" : "#FFFFFF",
          fontWeight: 700,
        },
        "&:disabled": {
          color: "#7E7E7E",
        },
      }}
      id={id != null ? id : null}
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );
}
